import { MapPin } from "lucide-react";
import { getDeptChipsForDisplay } from "@/lib/departementDisplay";
import { cn } from "@/lib/utils";

/**
 * Pastilles département alignées sur les cartes marketplace (DossierCard).
 */
export default function DeptLocationPills({ dossier, className, size = "sm" }) {
  const chips = getDeptChipsForDisplay(dossier);
  if (!chips.length) return null;

  const pill =
    size === "xs"
      ? "inline-flex items-center gap-1 rounded-full bg-slate-50 px-2 py-0.5 text-[10px] font-medium text-slate-700 ring-1 ring-slate-200/80"
      : "inline-flex items-center gap-1 rounded-full bg-slate-50 px-2.5 py-1 text-xs font-medium text-slate-700 ring-1 ring-slate-200/80";
  const icon = size === "xs" ? "h-3 w-3" : "h-3.5 w-3.5";

  return (
    <span className={cn("inline-flex flex-wrap items-center gap-1", className)}>
      {chips.map((code) => (
        <span key={code} className={pill}>
          <MapPin className={cn(icon, "shrink-0 text-[#2D7FF9]")} aria-hidden />
          <span className="tabular-nums">Dép. {code}</span>
        </span>
      ))}
    </span>
  );
}
